import { render } from "./AddOrg.vue?vue&type=template&id=0e88dc79&scoped=true"
import script from "./AddOrg.vue?vue&type=script&lang=js"
export * from "./AddOrg.vue?vue&type=script&lang=js"

import "./AddOrg.vue?vue&type=style&index=0&id=0e88dc79&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e88dc79"]])

export default __exports__